// StringsContext.tsx
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import ContentServices from '@/services/content-services';
import Loader from '@/components/loader/loader';
type Strings = Record<string, string>;

const StringsContext = createContext<Strings>({});

export const useStrings = () => useContext(StringsContext);

export const StringsProvider = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(true);

  const [strings, setStrings] = useState<Strings>(() => {
    try {
      return JSON.parse(localStorage.getItem('strings') || '{}');
    } catch {
      return {};
    }
  });

  useEffect(() => {
    setLoading(true);

    const fetchStrings = async () => {
      try {
        const { data: response } = await ContentServices.strings();
        const { data } = response;
        setStrings(data);
      } catch (error) {
        console.error('Failed to load strings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStrings();
  }, []);

  return (
    <StringsContext.Provider value={strings}>
      <>
        {strings && children}
        <Loader visible={loading} />
      </>
    </StringsContext.Provider>
  );
};
